var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvgInventoryManagementFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1219_98031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.4999V6.66659L10 3.33325L17.5 6.66659V17.4999",
    stroke: "#216AE2",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 10.8333H14.1667V17.4999H5.83337V12.4999H10.8334",
    stroke: "#216AE2",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 17.5001V10.0001C10.8333 9.77907 10.7455 9.56711 10.5893 9.41083C10.433 9.25455 10.221 9.16675 10 9.16675H8.33333C8.11232 9.16675 7.90036 9.25455 7.74408 9.41083C7.5878 9.56711 7.5 9.77907 7.5 10.0001V12.5001",
    stroke: "#216AE2",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1219_98031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgInventoryManagementFocus);
export default __webpack_public_path__ + "static/media/svg_inventory_management_focus.cd5dcef391d35a08264dd784f4cd641f.svg";
export { ForwardRef as ReactComponent };